<template>
  <div>
    <el-card>
      <el-form class="demo-form-inline" size="mini" label-width="180px" style="min-width: 640px" ref="ruleForm"
        :rules="rules">
        <el-form-item>
          <el-button-group v-if="page_type == 'detail'">
            <template v-if="edit">
              <el-button type="primary" @click="save" size="mini">保存</el-button>
              <el-button type="primary" @click="reload" size="mini">取消</el-button>
            </template>
            <el-button type="primary" @click="handleEdit()" size="mini" v-else>编辑</el-button>
          </el-button-group>
          <el-button-group v-else>
            <el-button type="primary" @click="post" size="mini" v-if="edit">提交</el-button>
          </el-button-group>
        </el-form-item>
        <el-form-item label="头像：">
          <!-- action="https://upload.qbox.me/" -->
          <el-upload action="https://up-z1.qbox.me/" :show-file-list="false" :on-success="handleSuccess"
            :before-upload="beforeUpload" :data="uploadData">
            <img v-if="item.avatar" :src="item.avatar" style="width: 100px; height: 100px" class="avatar" />
            <i v-else style="
                display: flex;
                align-items: center;
                justify-content: center;
              " class="el-icon-plus avatar-uploader-icon"></i>
            <el-input type="hidden" v-model="item.avatar"></el-input>
          </el-upload>
          <div>
            <el-button v-if="edit" @click="item.avatar = '/static/headshot-default.png'">头像不合法，设置成默认头像
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="昵称：">
          <el-input v-model="item.nickname" placeholder="输入名字" size="small" v-if="edit"></el-input>
          <span v-else>{{ item.nickname }}</span>
        </el-form-item>

        <el-form-item label="身份证号：">
          {{ item.idNo }}
        </el-form-item>
        <el-form-item label="" v-if="item.idCardPositive || item.idCardNegative">
          <div class="demo-image__preview">
            <span>
              <img v-if="item.idCardPositive" class="el-image__inner" :src="item.idCardPositive" alt=""
                @click="handleViewPositive(item)" />
            </span>
            <span>
              <img v-if="item.idCardNegative" class="el-image__inner" :src="item.idCardNegative" alt=""
                @click="handleView(item)" />
            </span>
          </div>
        </el-form-item>
        <el-form-item label="手机：">
          <el-input v-model.trim="item.phoneNumber" placeholder="输入手机" size="small" v-if="edit"
            autocomplete="new-password"></el-input>
          <span v-else>{{ item.phoneNumber }}</span>
        </el-form-item>
        <el-form-item label="密码：">
          <el-input style="width: 460px" v-model="item.password" size="small" v-if="edit" type="password"
            autocomplete="new-password"></el-input>
          <el-input v-else style="width: 460px" type="password" disabled v-model="item.password"></el-input>
        </el-form-item>
        <el-form-item label="角色：">
          <el-select disabled style="width: 200px" v-model="item.role">
            <el-option :value="1" label="甲方"></el-option>
            <el-option :value="2" label="乙方"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手续费率：" prop="fee">
          <el-input style="width: 200px" :disabled="disabledEdit" v-model.trim="item.fee" size="mini"
            placeholder="请输入手续费率" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>

          <span> %</span>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input style="width: 460px" type="textarea" v-model="item.remark" size="small" maxLength="1000"
            v-if="edit"></el-input>
          <el-input style="width: 460px" v-else type="textarea" disabled v-model="item.remark"></el-input>
        </el-form-item>
        <el-form-item label="帐号状态：">
          {{ accountStatus[item.isDeleted] }}
        </el-form-item>

        <el-form-item>
          <el-button-group>
            <el-button :disabled="item.isDeleted === 0" @click="updateBanStatus(0)">解除</el-button>
            <el-button :disabled="item.isDeleted === 2" @click="submitBanStatus(2)">警告</el-button>
            <el-button @click="submitBanStatus(1)">封禁</el-button>
            <el-button :disabled="!applyId || !item.hasApply" @click="submitBanApplyStatus(2)">解封申请不通过</el-button>

            <el-button :disabled="item.isLimit === 1" @click="updateLimit(1)">加入灰名单</el-button>
            <el-button :disabled="item.isLimit === 0" @click="updateLimit(0)">移出灰名单</el-button>

          </el-button-group>
        </el-form-item>
        <template v-if="isDeleted > 0">
          <el-form-item label="选择警告或封禁结束时间">
            <el-date-picker v-model="unblockTime" type="datetime" placeholder="警告或封禁结束时间" format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button-group>
              <el-button @click="updateBanStatus(-1)">取消</el-button>
              <el-button @click="updateBanStatus(1)">确认</el-button>
            </el-button-group>
          </el-form-item>
        </template>

        <el-form-item label="操作记录">
          <p v-for="record in item.banHistory">{{ formatReaord(record) }}</p>
        </el-form-item>
      </el-form>
    </el-card>
    <el-dialog title="预览身份证图片" :visible.sync="dialogVisible">
      <img width="100%" height="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import api from "../api";

export default {
  name: "userItem",
  data() {
    return {
      item: {
        avatar: "",
        fee: 0,
      },
      accountStatus: {
        0: "正常",
        1: "封禁",
        2: "警告",
      },
      originItem: {},
      edit: false,
      userId: this.$route.query.id,
      page_type: "detail",
      searchList: [],
      load: false,
      uploadData: {
        token: "",
        name: "",
        chunk: 0,
        chunks: 1,
      },
      isDeleted: 0,
      unblockTime: "", // 警告或封禁结束时间
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      disabledEdit: true,
      dialogVisible: false,
      dialogImageUrl: "", // 预览地址
      rules: {
        // fee: [{ required: true, message: "请输入手续费率", trigger: "blur" }],
      },
    };
  },
  computed: {
    applyId() {
      return Number(this.$route.query.applyId) || "";
    },
    // userId() {
    //   return this.$route.query.id;
    // },
  },
  methods: {
    handleEdit() {
      this.edit = true;
      this.disabledEdit = false;
    },
    async getToken() {
      let res = await api.upload.token();
      if (res.data.code == 200) {
        this.uploadData.token = res.data.data.up_token;
      }
    },
    async fetch() {
      let res = await api.user.detail({ userIdEnc: this.$route.query.id });

      let item = res.data.data;

      this.item = item;
      this.originItem = JSON.parse(JSON.stringify(item));
    },
    async save() {
      let {
        userId,
        password,
        avatar,
        nickname,
        phoneNumber,
        role,
        remark,
        fee,
      } = this.item;
      let params = {
        userId,
        nickname,
        phoneNumber,
        avatar,
        role,
        remark,
        fee: Number(fee),
      };
      if (password !== this.originItem.password) {
        params.password = password;
      }
      if (this.item.fee && this.item.fee.length < 1) {
        return this.$message.error("手续费率不能为空！");
      }
      let {
        data: { code },
      } = await api.user.update(params);
      if (code === 200) {
        this.$message.success("更新用户成功");
        this.edit = false;
        this.disabledEdit = true;
        // setTimeout(() => {
        //   window.location.reload();
        // }, 500);
      }
    },
    async reload() {
      await this.fetch();
      this.edit = false;
      this.disabledEdit = true;
      this.load = true;
    },
    submitBanStatus(st) {
      this.isDeleted = st;
      console.log(this.isDeleted);
      this.unblockTime = "";
    },
    async updateBanStatus(st) {
      if (st > 0 && !this.unblockTime) {
        this.$message.error("请选择警告或者封禁结束时间！");
        return false;
      }
      if (st === -1) {
        this.isDeleted = 0;
        this.unblockTime = "";
      } else {
        let {
          data: { code },
        } = await api.user.updateBanStatus({
          aesId: this.$route.query.id,
          isDeleted: this.isDeleted,
          unblockTime: this.unblockTime,
        });
        if (code === 200) {
          this.fetch();
          this.isDeleted = 0;
          this.unblockTime = "";
        }
      }
    },
    async submitBanApplyStatus(st) {
      // st 解封申请处理状态（1：处理 2：不解封）
      let {
        data: { code },
      } = await api.user.updateUnBanApply({
        id: this.applyId,
        applyStatus: st,
      });
      if (code === 200) {
        this.$message.success("解封申请不通过已处理完成");
        this.fetch();
      }
    },
    async updateLimit(st) {
      let {
        data: { code },
      } = await api.user.updateLimit({
        userId: this.item.userId,
        isLimit: st,
      });
      if (code === 200) {
        this.$message.success("操作成功");
        this.fetch();
      }
    },
    handleSuccess(res, file) {
      this.item.avatar = `https:\/\/image.duiyou360.com/${res.key}`;
    },
    beforeUpload(file) {
      let sizeM = file.size / 1024 / 1024;
      this.chunks = Math.ceil(sizeM / 10); // 大于10m文件进行分片
      this.uploadData.name = file.name;

      /*
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
            */
    },
    formatReaord(record) {
      let operators = {
        1: "用户",
        2: "运营",
        3: "系统",
      };
      let types = {
        1: "封禁",
        2: "警告",
        3: "解封",
      };
      if (record.type === 3) {
        return `${record.createTime} 由${operators[record.operator]}触发${types[record.type]
          }`;
      } else {
        return `${record.createTime} 由${operators[record.operator]}触发${types[record.type]
          }，${types[record.type]}至 ${record.unblockTime}`;
      }
    },
    // 预览
    handleViewPositive(item) {
      this.dialogImageUrl = item.idCardPositive;
      this.dialogVisible = true;
    },
    handleView(item) {
      this.dialogImageUrl = item.idCardNegative;
      this.dialogVisible = true;
    },
  },
  async mounted() {
    this.reload();
    this.getToken();
  },
  created() { },
};
</script>
<style>
#mapContainer {
  height: 600px;
}

.search-list {
  box-shadow: 0 5px 20px 0 rgba(9, 34, 53, 0.1);
  position: absolute;
  left: 0;
  top: 30px;
  right: 0;
  z-index: 200;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-bottom: none;
}

.search-list .item {
  font-size: 14px;
  text-indent: 10px;
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.avatar {
  width: 100px;
  height: 100px;
  text-align: center;
  line-height: 100px;
  color: #ffffff;
  font-size: 20px;
  border-radius: 50%;
}

.avatar-uploader-1 .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-1 .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: dashed 1px #dcdfe6;
}

.avatar-idCard {
  width: 178px;
  height: 178px;
  display: block;
}

.el-image__inner {
  width: 200px !important;
  height: 100px !important;
  margin-right: 20px;
}
</style>
<style scoped>
.demo-image__preview {
  display: flex;
}

.image__inner-flex {
  width: 200px !important;
  height: 100px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-icon-picture-outline {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/user/user-item.vue